import MutateApiHookType from '@trinsly/common/src/types/mutate-api-hook-type'
import { useMutation, useQueryClient } from 'react-query'
import requestIntegrationService from 'services/request-integration-service'

type UseRequestIntegrationProps = {} & MutateApiHookType<void>

function useRequestIntegration({
  onSuccess,
  onError,
}: UseRequestIntegrationProps) {
  const queryClient = useQueryClient()
  const { mutate: fetch, isLoading: pending } = useMutation(
    requestIntegrationService,
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries('/integrations')
        onSuccess?.()
      },
      onError,
    }
  )

  return {
    fetch,
    pending,
  }
}

export default useRequestIntegration
